type EventListener = () => void;

export default class StoreSubscriber {
    readonly #subscribers: Set<EventListener>;

    constructor() {
        this.#subscribers = new Set();
    }
    subscribe = (callback: EventListener) => {
        this.#subscribers.add(callback);

        return () => {
            this.#subscribers.delete(callback);
        };
    };

    protected updateStore(updater: () => void) {
        updater();
        this.#runSubscriptions();
    }

    #runSubscriptions() {
        for (const subscriber of this.#subscribers) {
            subscriber();
        }
    }
}
